import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ResumoVo} from '~model/vo/resumo-vo';
import {MatSort} from '@angular/material/sort';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {ResumoPoiVo} from '~model/vo/resumo-poi-vo';
import {DocumentosService} from '~core/api/documentos.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {prioridadePAE} from '~model/vo/visita-vo';
import {asyncScheduler, BehaviorSubject} from 'rxjs';
import {DocumentoReferencia} from '~shared/components/rota-detalhes-dialog/rota-detalhes-dialog.component';
import {TranslateService} from '@ngx-translate/core';
import {observeOn} from 'rxjs/operators';
import {downloadFile} from '~utils/file-utils';

@Component({
  selector: 'app-rota-detalhes-relatorio',
  templateUrl: './rota-detalhes-relatorio.component.html',
  styleUrls: ['./rota-detalhes-relatorio.component.scss'],
  providers: [DocumentosService],
})
export class RotaDetalhesRelatorioComponent implements OnInit {
  @Input() resumo$!: BehaviorSubject<ResumoVo>;
  @Input() loaded$!: BehaviorSubject<boolean>;
  @Input() docLoaded$!: BehaviorSubject<boolean>;
  @Input() documentos$!: BehaviorSubject<DocumentoReferencia[]>;
  @Output() downloadFile$: EventEmitter<DocumentoReferencia> = new EventEmitter();
  loaded: boolean = false;

  emptyDate = '__:__';
  @ViewChild(MatSort, {static: true}) sort!: MatSort;
  @ViewChild('tableRelatorio', {static: false}) tableRelatorio!: MatTable<ResumoPoiVo>;
  resumoPOIsDataSource: MatTableDataSource<ResumoPoiVo> = new MatTableDataSource<ResumoPoiVo>([]);
  displayedColumns = ['status', 'numeroOrdem', 'codigo', 'imagem', 'assinatura', 'cliente', 'inicio', 'saida'];
  theme = {transform: 'scale(.6)', margin: 0};

  constructor(
    private service: DocumentosService,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.loaded$.pipe(observeOn(asyncScheduler)).subscribe(loaded => {
      this.resumo$.subscribe(resumo => {
        if (loaded) {
          this.resumoPOIsDataSource.data = resumo.resumoPOIs.filter(r => r.tipo === 'TIPO_PEDIDO').map(poi => {
            poi.chegada = prioridadePAE(poi.horaChegada);
            poi.saida = prioridadePAE(poi.horaSaida);
            return poi;
          });
        }

        this.loaded = loaded;
      });
    });
  }

  downloadImg(pedido: string): void {
    this.downloadTipo(pedido);
  }

  downloadAss(pedido: string): void {
    this.downloadTipo(pedido, 'IMAGEM_ASSINATURA');
  }

  downloadTipo(pedido: string, tipo?: string): void {
    this.translate.get('ROUTE_REPORT.PRINTING').subscribe((translate: {[k: string]: string}) => {
      const referencias = this.documentos$.value.filter(d => d.pedido.codigo === pedido && (!tipo || d.arquivo.tipo === tipo));
      this.snackbar.open(translate.DOWNLOADING, undefined, {duration: 3000});
      if (referencias.length > 0) {
        const arquivos = referencias.map(r => ({pasta: r.pedido.codigo, link: r.arquivo.linkDownload}));
        const comp = pedido ? `${pedido}${tipo ? '_' + tipo : ''}` : '';
        const nomeDoArquivo = `Anexos_${this.resumo$.value.data}_${this.resumo$.value.placa}_${comp || 'todos'}.zip`;
        this.service.geraZipDocumentos(arquivos).pipe(observeOn(asyncScheduler, 500))
          .subscribe(res => {
            const file = downloadFile(res, nomeDoArquivo, translate.DOWNLOADED);
            this.snackbar.open(file, undefined, {duration: 3000});
          });
      } else {
        const docOrSign = tipo === 'IMAGEM_ASSINATURA' ? translate.SIGNATURES : translate.DOCUMENTS;
        const message = translate.NO_DOWNLOAD_TARGETS.replace('{{doc_or_sign}}', docOrSign);
        this.snackbar.open(message, undefined, {duration: 3000});
      }
    });
  }

  possuiImg(pedido: string): boolean {
    return this.possuiTipo(pedido);
  }

  possuiAss(pedido: string): boolean {
    return this.possuiTipo(pedido, 'IMAGEM_ASSINATURA');
  }

  possuiTipo(pedido: string, tipo?: string): boolean {
    const referencias = this.documentos$.value.filter(d => d.pedido.codigo === pedido && (!tipo || d.arquivo.tipo === tipo));
    return referencias.length > 0;
  }
}
